export const chartColors = ['#182885', '#6d2289', '#a51581', '#d11a71', '#f13b5c', '#ff6343', '#ff8e27', '#ffb800']

export default {
    axisStrokeColor: '#0f1243',
    axisTickColor: 'blue',
    axisTextColor: 'blue',
    gridRowColor: '#151a6d',
    gridRowOpacity: 0.35,
    verticalTooltipLineStrokeColor: 'blue',
    axisBottomFontSize: 40,
    axisLeftFontSize: 40,
    axisLeftProps: {
        dx: '-0.25em',
        dy: '0.25em',
        fontFamily: 'IBM Plex Sans',
        fontSize: 10,
        textAnchor: 'end' as const,
        fill: 'red',
    },
    axisBottomProps: {
        textAnchor: 'middle' as const,
        fontFamily: 'Arial',
        fontSize: 10,
        fill: 'red',
    },
    lineGradientBackgroundFrom: 'blue',
    lineGradientBackgroundTo: 'blue',
    lineGradientAccentFrom: 'blue',
    lineGradientAccentTo: 'blue',
    legend: {
        fontSize: '10px',
        fontWeight: 600,
    },
    tooltip: {
        background: '#fff',
        color: '#fff',
    },
    colors: chartColors,
}
